import BaseServiceRead from './BaseServiceRead';

export default class HistoryService extends BaseServiceRead {
	// Initializing important variables
	constructor() {
		super();
		this.path = 'history';
	}
	getCriteria(criteria) {
		return this.objToQueryString({
			month: criteria.month ? criteria.month.month : undefined,
			year: criteria.month ? criteria.month.year : undefined,
			user_agreement_map_id: criteria.userAgreementMap ? criteria.userAgreementMap.id : undefined,
			first_result: criteria.firstResult,
			max_result: criteria.maxResults,
			sort_field: criteria.sortField,
			sort_asc: criteria.sortAsc,
		});
	}
}
